/**
 * Lightweight fetch wrapper.
 * Auth is handled via httpOnly cookie — no token in JS memory.
 * Returns { data } on success (matches axios destructure patterns).
 * Throws with err.response.data on non-2xx (matches axios error patterns).
 */

async function request(method, url, body, isFormData) {
  const headers = {};
  if (body && !isFormData) headers['Content-Type'] = 'application/json';

  const res = await fetch(url, {
    method,
    headers,
    credentials: 'include', // send httpOnly cookie with every request
    body: body != null ? (isFormData ? body : JSON.stringify(body)) : undefined,
  });

  const ct = res.headers.get('content-type') || '';
  const payload = ct.includes('application/json') ? await res.json() : await res.text();

  if (!res.ok) {
    const err = new Error(payload?.error || payload?.message || 'Request failed');
    err.response = { data: payload, status: res.status };
    throw err;
  }

  return { data: payload };
}

const api = {
  get(url, opts) {
    if (opts?.params) {
      const qs = new URLSearchParams(opts.params).toString();
      url = url + (url.includes('?') ? '&' : '?') + qs;
    }
    return request('GET', url);
  },
  post(url, body) {
    return request('POST', url, body, body instanceof FormData);
  },
  put(url, body)   { return request('PUT',    url, body); },
  patch(url, body) { return request('PATCH',  url, body); },
  delete(url)      { return request('DELETE', url); },
};

export default api;
